import * as z from "zod";
import { exchangeOrderShippingPriceSource } from "./get-commerce-cloud-setup";
import { commerceCloudIntegrationId } from "./list-commerce-cloud-integrations";

export const setCommerceCloudExchangeOrderMethods = {
  name: "setCommerceCloudExchangeOrderMethods" as const,
  input: z.object({
    integrationId: commerceCloudIntegrationId,
    shippingMethodId: z.string().trim().min(1).nullable(),
    paymentMethodId: z.string().trim().min(1).nullable(),
    cartridgeEnabled: z.boolean(),
    shippingPriceSource: exchangeOrderShippingPriceSource,
  }),
  output: z.null(),
};
